import React from "react";
import metalogo from "../Assets/metaverselogo.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faInstagram } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="w-full bg-gradient-to-br from-gray-900 to-black">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="py-10 flex justify-between items-center flex-col gap-8 xl:flex-row">
          <div className="flex items-center flex-col xl:flex-row">
            <img src={metalogo} alt="" width={100} height={100} />
            <ul className="text-lg flex items-center flex-col md:flex-row py-8 gap-6 md:gap-12 xl:border-l border-gray-200 xl:ml-11 xl:pl-11 transition-all duration-500">
              <li>
                <a
                  href="/members"
                  className="text-gray-800 hover:text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-500"
                >
                  Members
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-gray-800 hover:text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-500"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/blog"
                  className="text-gray-800 hover:text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-500"
                >
                  Blog
                </a>
              </li>
            </ul>
          </div>
          <div className="flex space-x-4 sm:justify-center">
            <a
              href="#"
              className="group w-9 h-9 rounded-full border border-gray-300 flex justify-center items-center transition-all duration-500 hover:border-transparent bg-clip-border bg-gradient-to-r from-green-400 to-blue-500"
            >
              <FontAwesomeIcon
                icon={faLinkedin}
                className="text-gray-700 transition-all duration-500 group-hover:text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-500"
                size="lg"
              />
            </a>
            <a
              href="#"
              className="group w-9 h-9 rounded-full border border-gray-300 flex justify-center items-center transition-all duration-500 hover:border-transparent bg-clip-border bg-gradient-to-r from-green-400 to-blue-500"
            >
              <FontAwesomeIcon
                icon={faInstagram}
                className="text-gray-700 transition-all duration-500 group-hover:text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-500"
                size="lg"
              />
            </a>
          </div>
        </div>
        <div className="py-7 border-t border-gray-200">
          <div className="flex items-center justify-center">
            <span className="text-gray-400">
              Created by{" "}
              <a
                className="font-bold text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-blue-500 text-xl"
                href="https://mukilan.co/"
              >
                Mukilan T
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
